export const getOptions = (t: (key: string) => string) => [
  { label: t('monitoring.byRegions'), value: 'region' },
  { label: t('monitoring.byIncidents'), value: 'opp_type' },
];

export const mapSelectItems = [];
